import _styled from "styled-components";
var _excluded = ["css", "style", "tagName", "children"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lightThemeObject } from "../../styleguide";
export var CardWrapper = styled.div.withConfig({
  displayName: "Card__CardWrapper",
  componentId: "sc-1yeigd8-0"
})(["box-shadow:0 1px 0 0 rgba(0,0,0,0.25);background-color:var(--bui-background,", ");border-radius:4px;overflow:hidden;", ";"], lightThemeObject['--bui-background'], function (props) {
  return props.css;
});

var _StyledCardWrapper = styled(CardWrapper).withConfig({
  displayName: "Card___StyledCardWrapper",
  componentId: "sc-1yeigd8-1"
})(["", ""], function (p) {
  return p.$_css;
});

var Card = function Card(_ref) {
  var css = _ref.css,
      style = _ref.style,
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(_StyledCardWrapper, _extends({
    as: tagName,
    style: style
  }, other, {
    $_css: css
  }), children);
};

Card.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Overriding css object
   */
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /**
   * Overriding style object
   */
  style: PropTypes.object,

  /**
   * Type of HTML-tag output.
   */
  tagName: PropTypes.string,

  /**
   * Child components
   */
  children: PropTypes.node
} : {};
export default Card;
//# sourceMappingURL=Card.js.map